/// <amd-module name="TFS/Samples/MasterDetails/TopMasterView" />
import * as React from "react";
import { Card } from "VSSUI/Card";
import { Header } from "VSSUI/Header";
import { Page } from "VSSUI/Page";
import { ITableColumn, ITableRow, SimpleTableCell, Table, TwoLineTableCell } from "VSSUI/Table";
import { IItemProvider } from "VSSUI/Utilities/Provider";
import { IPullRequest } from "./SampleData";

const tableColumns: ITableColumn<IPullRequest>[] = [
    {
        id: "title",
        name: "Title",
        width: -33,
        renderCell: (rowIndex, colIndex, tableColumn, pullRequest) => (
            <TwoLineTableCell
                key={pullRequest.hashCode + colIndex}
                columnIndex={colIndex}
                tableColumn={tableColumn}
                line1={<div>{pullRequest.title}</div>}
                line2={<div className="secondary-text fontSizeS">{pullRequest.hashCode}</div>}
            />
        )
    },
    {
        id: "author",
        name: "Author",
        width: -33,
        renderCell: (rowIndex, colIndex, tableColumn, pullRequest) => (
            <SimpleTableCell key={pullRequest.hashCode + colIndex} columnIndex={colIndex} tableColumn={tableColumn}>
                <div>{pullRequest.author}</div>
            </SimpleTableCell>
        )
    },
    {
        id: "date",
        name: "Date",
        width: -33,
        renderCell: (rowIndex, colIndex, tableColumn, pullRequest) => (
            <SimpleTableCell key={pullRequest.hashCode + colIndex} columnIndex={colIndex} tableColumn={tableColumn}>
                <div>{pullRequest.dateTime}</div>
            </SimpleTableCell>
        )
    }
];

export interface ITopMasterViewProps {
    itemProvider: IItemProvider<IPullRequest>;
    onPullRequestSelected: (event: any, pullRequest: ITableRow<IPullRequest>) => void;
}

export const TopMasterView: React.FunctionComponent<ITopMasterViewProps> = props => {
    return (
        <Page className="flex-grow">
            <Header title="Pull Requests" description="Click in the table to drill down" />
            <div className="page-content page-content-top">
                <Card className="flex-grow bolt-card-no-vertical-padding" contentProps={{ contentPadding: false }}>
                    <Table
                        columns={tableColumns}
                        itemProvider={props.itemProvider}
                        showLines={true}
                        singleClickActivation={true}
                        onActivate={props.onPullRequestSelected}
                    />
                </Card>
            </div>
        </Page>
    );
};
